<template>
	<modal
		:modal-id="modalId"
		:title="modalTitle"
		:preloader="preloader"
		@submit="submit"
		@close-modal="closeModal"
	>
		<template slot="body">
			<app-overlay-loader v-if="preloader" />
			<form
				class="mb-0"
				:class="{ 'loading-opacity': preloader }"
				ref="form"
                method="PUT"
				:data-url="`transaction/lead/${this.value.id}`"
			>

				<div class="form-group row align-items-center">
					<label for="inputs_created_at" class="col-sm-3 mb-0">
						Created Date
					</label>
                        
					<input
						id="inputs_created_at"
						class="col-sm-9 form-control"
						type="date"
						v-model="ui_date"
						placeholder="Created Date"
						required
					/>

				</div>
				<div class="form-group row align-items-center">
                    <div class="col-md-12">
                        <br>
                        <br>
                        <br>
                    </div>
                </div>
				<div class="form-group row align-items-center">
                    <div class="col-md-12">
                        <br>
                        <br>
                        <br>
                        <br>
                        <br>
                    </div>
                </div>
			</form>
		</template>
	</modal>
</template>

<script>
import { FormMixin } from "../../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../../Mixins/ModalMixin";

export default {
	name: "CreateDateForm",
	mixins: [FormMixin, ModalMixin],
	props: {
		tableId: String,
		formId: String,
		value: {
			type: Object,
			default: () => {
				return {
					code: "",
					name: "",
					is_active: "",
				};
			},
		},
	},
	data() {
		return {
			preloader: false,
			modalId: this.formId,
			modalTitle: this.$t("add"),
            original_created_at: "",
			inputs: {
				id: "",
				created_at: "",
			},
            ui_date: "",
		};
	},
	created() {
        const raw = this.value.created_at;

        // Ambil jam yang valid HH:mm:ss
        const timeMatch = raw.match(/\b\d{2}:\d{2}:\d{2}\b/);

        this.original_created_at = raw;
        const timePart = timeMatch ? timeMatch[0] : '00:00:00';

        this.ui_date = raw.substring(0, 10);
        this.inputs.created_at = raw.substring(0, 10);

        // Simpan jam yang bener
        this.original_time = timePart;
        
        this.inputs.id = this.value.id;
        this.modalTitle = this.$t("edit");
	},
	methods: {
		
		submit() {
            const timeMatch = this.original_created_at.match(/\b\d{2}:\d{2}:\d{2}\b/);
            const timePart = timeMatch ? timeMatch[0] : '00:00:00';

            const fullTimestamp = `${this.ui_date} ${timePart}`;
                this.inputs.created_at = fullTimestamp;
                this.save(this.inputs); 
            },
		afterSuccess(response) {
			this.$toastr.s(response.data.message);
           
            this.$emit("updated");

            this.$emit("close-modal");
		},
		
		afterSuccessFromGetEditData(response) {
            const raw = response.data.created_at;

            const timeMatch = raw.match(/\b\d{2}:\d{2}:\d{2}\b/);
            const timePart = timeMatch ? timeMatch[0] : '00:00:00';
            this.original_created_at = raw;
            this.ui_date = raw.substring(0, 10);
            this.inputs.id = response.data.id;

            this.original_time = timePart;
			this.preloader = false;
		},
	},
};
</script>
<style scoped>
::v-deep(.modal-body) {
  min-height: 38vh !important;
}
</style> 